import { v4 as uuidv4 } from 'uuid';
import { MessageMedia } from "./message.model";

export class PostLineModel {
    _id?: any;
    uuid: string;
    revision: string;
    status: string;
    vrsn: string;
    create_date: Date;
    update_date: Date;
    post_id: string;
    post_type: string;
    message_media?:  MessageMedia;
    created_by?: string;
    updated_by?: string;

  constructor(pageId: string, postType: string){
    this.uuid = uuidv4();
    this.revision = uuidv4();
    this.status = "ACTIVE";
    this.vrsn = "ailedger-v1"
    this.create_date = new Date();
    this.update_date = new Date();
    this.post_id = pageId;
    this.post_type = postType;
  }

}